import React, { Component } from 'react';

import './YoutubeVideoImage.css';

class YoutubeVideoImage extends Component {

    getYoutubeUrl() {
        return "https://youtube.com/watch?v="+this.props.videoId;
    }

    getYoutubeThumbnailUrl() {
        return "//img.youtube.com/vi/"+this.props.videoId+"/mqdefault.jpg";
    }

    onClick(e) {
        window._paq.push(['trackEvent', 'YoutubeVideo', 'Click', this.props.videoId])
    }

    render() {
        return (
            <div className="youtube-video-image-wrapper">
                <a href={this.getYoutubeUrl()} target="_BLANK" onClick={this.onClick.bind(this)}>
                    <span className="glyphicon glyphicon-play" />

                    <img className="img-responsive youtube-video-image"
                        alt="youtube-video"
                        src={this.getYoutubeThumbnailUrl()} />
                </a>
            </div>
        );
    }

}

export default YoutubeVideoImage;



// WEBPACK FOOTER //
// ./src/components/YoutubeVideoImage.js